import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { AuthProvider } from '../auth';
import { RealtimeProvider } from '../features/realtime';

/**
 * Provedores globais. O QueryClient vem de fora para os testes poderem criar o seu (sem retry). O
 * tempo real fica dentro da autenticação (precisa saber quem está conectado) e, por vir de fora, do
 * roteador (precisa saber qual conversa está aberta).
 */
export function AppProviders({
  queryClient,
  children,
}: {
  queryClient: QueryClient;
  children: ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RealtimeProvider>{children}</RealtimeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
